export const HEIGHT_CHANGED_MESSAGE_TYPE = "HeightChanged";
